export default "__VITE_ASSET__Bw8uwrT8__"